import React from 'react'

import Buttons from '../../slices/Buttons'
import CampaignTiles from '../../slices/CampaignTiles'
import Carousel from '../../slices/Carousel'
import Content from '../../slices/Content'
import ContentImage from '../../slices/ContentImage'
import Countdown from '../../slices/Countdown'
import DonationTicker from '../../slices/DonationTicker'
import DynamicBanner from '../../slices/DynamicBanner'
import FAQs from '../../slices/FAQs'
import FeaturedCharities from '../../slices/FeaturedCharities'
import FitnessLeaderboards from '../../slices/FitnessLeaderboards'
import FundraisingLeaderboards from '../../slices/FundraisingLeaderboards'
import Gallery from '../../slices/Gallery'
import GridContent from '../../slices/GridContent'
import HTMLContent from '../../slices/HTMLContent'
import IFrame from '../../slices/IFrame'
import ImageLinks from '../../slices/ImageLinks'
import Links from '../../slices/Links'
import Metrics from '../../slices/Metrics'
import Modal from '../../slices/Modal'
import PageProgressTiles from '../../slices/PageProgressTiles'
import ProgressBar from '../../slices/ProgressBar'
import ProjectLeaderboard from '../../slices/ProjectLeaderboard'
import ProjectMetrics from '../../slices/ProjectMetrics'
import ProjectSearch from '../../slices/ProjectSearch'
import ProjectTiles from '../../slices/ProjectTiles'
import Registration from '../../slices/Registration'
import Resources from '../../slices/Resources'
import SocialFeedCurator from '../../slices/SocialFeedCurator'
import SocialFeedDefault from '../../slices/SocialFeedDefault'
import SocialShare from '../../slices/SocialShare'
import StaticBanner from '../../slices/StaticBanner'
import SupporterSearch from '../../slices/SupporterSearch'
import SupporterTiles from '../../slices/SupporterTiles'
import Video from '../../slices/Video'

const sliceComponents = {
  buttons: Buttons,
  campaignTiles: CampaignTiles,
  carousel: Carousel,
  content: Content,
  contentImage: ContentImage,
  countdown: Countdown,
  donationTicker: DonationTicker,
  dynamicBanner: DynamicBanner,
  faqs: FAQs,
  featuredCharities: FeaturedCharities,
  fitnessLeaderboards: FitnessLeaderboards,
  fundraisingLeaderboards: FundraisingLeaderboards,
  gallery: Gallery,
  gridContent: GridContent,
  htmlContent: HTMLContent,
  iframe: IFrame,
  imageLinks: ImageLinks,
  links: Links,
  metrics: Metrics,
  modal: Modal,
  pageProgressTiles: PageProgressTiles,
  progressBar: ProgressBar,
  projectLeaderboard: ProjectLeaderboard,
  projectMetrics: ProjectMetrics,
  projectSearch: ProjectSearch,
  projectTiles: ProjectTiles,
  registration: Registration,
  resources: Resources,
  socialFeedCurator: SocialFeedCurator,
  socialFeedDefault: SocialFeedDefault,
  socialShare: SocialShare,
  staticBanner: StaticBanner,
  supporterSearch: SupporterSearch,
  supporterTiles: SupporterTiles,
  video: Video
}

const SliceProcessor = ({
  slices = []
}) => (
  <main id='main' role='main'>
    {slices.map((slice, index) => {
      const Component = sliceComponents[slice.type]

      const duplicateCount = slices.slice(0, index).filter(({ type }) => type === slice.type).length
      const id = `${slice.type}${duplicateCount > 0 ? `-${index}` : ''}`

      const props = {
        ...slice.primary,
        items: slice.items
      }

      return (
        <div key={index} id={id}>
          {Component
            ? <Component {...props} />
            : `Unknown slice type: ${slice.type}`}
        </div>
      )
    })}
  </main>
)

export default SliceProcessor



// WEBPACK FOOTER //
// ./components/utils/SliceProcessor/index.js